<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :footer="footer"
    :config="config"
    ref="table"
  >
  </cTable>
</template>

<script>
import {
  getDetails,
  exportDetails,
  hangBill,
  deleteDetails,
} from "@/api/finance/hw_bill_hq";
import { getDetails as getDetails1 } from "@/api/finance/hw_bill_branch";
import { getExpense } from "@/api/finance/expense";
import { getCountry } from "@/api/system/country";

import cTable from "@/base/common/index";

export default {
  components: {
    cTable,
  },
  props: {
    rows: {
      type: Object,
    },
  },
  computed: {
    isClient() {
      return this.config.rows.target_type != 2;
    },
  },
  data() {
    return {
      config: {
        slot: "div",
        rows: this.rows,
        exportConfig({ column }) {
          return (
            [
              "trace",
              "shipment.trace_code",
              "shipment.trace_remarks",
              "shipment.trace_time",
              "financeInfo.quotation_name",
            ].indexOf(column.property) === -1
          );
        },
      },
      totalAmount: [],
      methods: {
        list: (p) => {
          p.id = this.config.rows.financeInfo.id;
          console.log(this.isClient ? getDetails1 : getDetails, this.isClient);
          // return this.isClient? getDetails(p): getDetails1(p);
          return getDetails(p);
        },
        getExpense,
        getCountry,
        exportDetails: exportDetails,
        hangBill,
        deleteDetails,
        // afterHandleList() {
        //   this.getTable().setAllRowExpand(true);
        // },
        // beforeHandleList: ({ data }) => {
        // if (this.totalAmount.length == 0) {
        //   this.totalAmount.push(
        //     {
        //       text: this.$t("total"),
        //       replace_currency: "CNY",
        //       total_amount: data.total_cny
        //     },
        //     {
        //       text: this.$t("total"),
        //       replace_currency: "USD",
        //       total_amount: data.total_usd
        //     }
        //   );
        // }
        // }
      },
      modals: {
        hang: {
          methods: {
            ok({ row, close }) {
              let data = row;
              data.ids = this.$page.selectAll.map((item) => item.id);
              data.id = this.$page.config.rows.financeInfo.id;
              this.$page.handleRequestMethods("hangBill", data).then((res) => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg,
                });
                this.$page.getList();
                close();
              });
            },
          },
          config: {
            modalBind: {
              width: 600,
            },
            formBind: {
              labelWidth: 80,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              remarks: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [{ remarks: 24 }],
          fields: [
            {
              name: () => this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("Remarks");
              },
              bind: {
                type: "textarea",
                rows: 5,
              },
            },
          ],
        },
        add: {
          methods: {
            ok({ row, close }) {
              this.$page.handleRequestMethods("addB2bBill", row).then((res) => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg,
                });
                this.$page.getList();
                close();
              });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              client_ids: [
                {
                  required: true,
                  type: "number",
                  message: this.$t("select") + this.$t("clientName"),
                  trigger: "change",
                },
              ],
              name: [
                {
                  required: true,
                  message: this.$t("enter") + this.$t("codNAme"),
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [{ client_ids: 24 }, { name: 24 }],
          fields: [
            {
              name: () => this.$t("clientName"),
              key: "client_ids",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("order_number"),
              options: [],
              config: { label: "account", value: "id" },
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getB2bBillUSer")
                  ).payload;
                  this.$forceUpdate();
                },
              },
            },
            {
              name: () => this.$t("codNAme"),
              key: "name",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("codNAme"),
            },
          ],
        },
        update: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("updateB2bBill", row)
                .then((res) => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg,
                  });
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              name: [
                {
                  required: true,
                  message: "Please Enter name",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [{ name: 24 }, { remarks: 24 }],
          fields: [
            {
              name: () => this.$t("codNAme"),
              key: "name",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("codNAme"),
            },
            {
              name: () => this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("Remarks"),
              bind: {
                rows: 5,
                type: "textarea",
              },
            },
          ],
        },
        writeOff: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = row;
              delete data.bill_order;
              data.airway_number = this.selectAll.map(
                (item) => item.airway_number
              );
              this.$page
                .handleRequestMethods("b2bWriteOff", data)
                .then((res) => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg,
                  });
                  this.$page.getList();
                  close();
                });
            },
            checkTable({ row }) {
              let amount = 0;
              row.map((item) => {
                amount += parseFloat(item.amount);
                return;
              });
              this.$refs["form"].formData.check_amount = amount;
              this.$forceUpdate();
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 120,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              contract_header: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change",
                  type: "number",
                },
              ],
              check_amount: [
                {
                  required: true,
                  type: "number",
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
              check_amount_currency: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change",
                },
              ],
              payment_bank: [
                {
                  required: true,
                  message: "cannot be empty",
                  type: "number",
                  trigger: "change",
                },
              ],
              payment_time: [
                {
                  required: true,
                  message: "cannot be empty",
                  type: "date",
                  trigger: "change",
                },
              ],
            },
          },
          grid: [
            { contract_header: 24 },
            { payment_bank: 24 },
            { payment_time: 24 },
            { check_amount: 24 },
            { check_amount_currency: 24 },
            { transaction_id: 24 },
            // { search_cnbnum: 24 }
          ],
          fields: [
            {
              name: () => this.$t("contract_title"),
              key: "contract_header",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("contract_title"),
              options: [],
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods(
                      "getB2bContractHeader"
                    )
                  ).payload;
                  this.$forceUpdate();
                },
              },
            },
            {
              name: () => this.$t("bank"),
              key: "payment_bank",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("bank"),
              options: [],
              config: {
                label({ row }) {
                  return row.account_type + "(" + row.bank_code + ")";
                },
                value: "id",
              },
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getBank")
                  ).payload;
                  this.$forceUpdate();
                },
              },
            },
            {
              name: () => this.$t("paid_time"),
              key: "payment_time",
              component: "DatePicker",
              placeholder: () => this.$t("select") + this.$t("paid_time"),
              bind: {
                type: "datetime",
                format: "yyyy-MM-dd HH:mm:ss",
              },
            },
            {
              name: () => this.$t("check_amount"),
              key: "check_amount",
              component: "InputNumber",
              bind: {
                min: 0,
                step: 0.0001,
                style: "width:100%",
              },
              default: 0,
            },
            {
              name: () => this.$t("check_amount_currency"),
              key: "check_amount_currency",
              component: "Select",
              placeholder: () =>
                this.$t("select") + this.$t("check_amount_currency"),
              options: [
                { label: this.$t("to_rmb"), value: "CNY" },
                { label: this.$t("to_usd"), value: "USD" },
              ],
            },
            {
              name: () => this.$t("transaction_id"),
              key: "transaction_id",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("transaction_id"),
            },
            // {
            //   name: () => this.$t("order_number"),
            //   key: "search_cnbnum",
            //   component: "Input",
            //   placeholder: () =>
            //     this.$t("enter") + this.$t("order_number") + this.$t("search"),
            //   methods: {
            //     "on-search"({ formData }) {
            //       let that = this.$page.getModal("writeOff");
            //       let arr = that.list;
            //       if (formData.search_cnbnum == "") {
            //         that.list = that.billOrder;
            //         return;
            //       }
            //       that.list = arr.filter(
            //         item =>
            //           item.search_cnbnum
            //             .toLowerCase()
            //             .indexOf(formData.search_cnbnum.toLowerCase()) !== -1
            //       );
            //     }
            //   },
            //   bind: {
            //     suffix: "ios-search",
            //     search: true
            //   }
            // }
          ],
          table: {
            config: {
              height: 300,
            },
            fields: [
              {
                type: "checkbox",
                width: 60,
                fixed: "left",
              },
              {
                name: () => this.$t("order_number"),
                key: "airway_bill_number",
                minWidth: 100,
              },
              {
                name: () => this.$t("reChAmount"),
                key: "amount",
                align: "left",
                minWidth: 100,
                // methods: {
                //   render() {
                //     return options.find(
                //       item =>
                //         item.value ==
                //         this.getModal("add").$refs["form"].formData.period
                //     ).label;
                //   }
                // }
              },
              // {
              //   name: () => this.$t("salesman"),
              //   key: "salesman_account",
              //   align: "left",
              //   minWidth: 100
              // }
            ],
          },
        },
        rate: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("b2bReStatistics", row)
                .then((res) => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg,
                  });
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 120,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              to_currency: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
              rate: [
                {
                  required: true,
                  type: "number",
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [{ to_currency: 24 }, { rate: 24 }],
          fields: [
            {
              name: this.$t("toCurrency"),
              key: "to_currency",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("toCurrency"),
              options: [
                { label: this.$t("to_rmb"), value: "CNY" },
                { label: this.$t("to_usd"), value: "USD" },
              ],
            },
            {
              name: () => this.$t("rate"),
              key: "rate",
              component: "InputNumber",
              bind: {
                min: 0,
                step: 0.0001,
                style: "width:100%",
              },
              default: 0,
            },
          ],
        },
        showDetails: {
          contentSlot: "DETAILS",
          config: {
            modalBind: {
              draggable: true,
              transfer: true,
              width: 1500,
            },
          },
          footer: { show: () => false },
        },
        feeModal: {
          footer: {
            show: () => false,
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 130,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
          },
          table: {
            config: {
              height: 500,
            },
            fields: [
              {
                name: () => this.$t("expense"),
                key: "expense_item_name",
                align: "center",
              },
              {
                name: this.$t("cost_t") + "(USD)",
                key: "amount_usd",
                align: "center",
              },
              {
                name: this.$t("cost_t") + "(CNY)",
                key: "amount_cny",
                align: "center",
              },
            ],
          },
        },
      },
      footer: {
        show: () => true,
        // render: h => {
        //   return h(
        //     "div",
        //     {
        //       class: "footer-content"
        //     },
        //     this.totalAmount.map(item => {
        //       return h(
        //         "div",
        //         {
        //           class: "footer-content-item"
        //         },
        //         [
        //           h("span", { class: "span-head" }, item.text),
        //           h(
        //             "span",
        //             { class: "span-head" },
        //             item.replace_currency + ":"
        //           ),
        //           h(
        //             "span",
        //             {
        //               class: "span-title"
        //             },
        //             numFun.formatNum(parseFloat(item.total_amount))
        //           )
        //         ]
        //       );
        //     })
        //   );
        // }
      },
      header: {
        searchs: [
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 1, maxRows: 2 },
            },
          },
        ],
        btns: {
          list: [
            {
              name: this.$t("export"),
              type: "export",
              fnName: "export",

              bind: {
                icon: "md-arrow-down",
                type: "primary",
              },
            },
            {
              name: this.$t("hang"),
              type: "hang",
              fnName: "hang",
              bind: {
                icon: "md-trash",
                type: "error",
              },
              disabled() {
                return !this.selectAll.length;
              },
            },
            {
              name: this.$t("delete"),
              type: "delete",
              fnName: "delete",
              bind: {
                icon: "md-trash",
                type: "error",
              },
              disabled() {
                return !this.selectAll.length;
              },
            },
          ],
          methods: {
            // 导出
            export() {
              this.handleRequestMethods(
                "exportDetails",
                this.config.rows.financeInfo.id,
                true,
                true
              ).then((res) => {
                window.open(this.$globalUrl + res.payload);
              });
            },
            hang() {
              this.getModal("hang").open({}, function () {
                this.setTitle(this.$t("hang"));
              });
            },
            delete() {
              this.$Modal.confirm({
                title: this.$t("whether") + this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  let data = {
                    id: this.config.rows.financeInfo.id,
                    ids: this.selectAll.map((item) => {
                      return item.id;
                    }),
                  };
                  this.handleRequestMethods("deleteDetails", data).then(
                    (res) => {
                      this.$Message["success"]({
                        background: true,
                        content: res.msg,
                      });
                      this.getList();
                    }
                  );
                },
              });
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          fixed: "left",
          width: 60,
        },
        {
          name: () => this.$t("order_t") + this.$t("type"),
          key: "type",
          width: 120,
        },
        {
          name: () => this.$t("CollectionUser"),
          key: "target_type_txt",
          width: 100,
        },
        {
          name: () => this.$t("warehouseName"),
          key: "warehouse_name",
          width: 100,
        },
        {
          name: () => this.$t("customsBill"),
          key: "str1",
          width: 120,
        },
        {
          name: () => this.$t("mawb"),
          key: "str2",
          width: 120,
        },
        {
          name: () => this.$t("cross_port") + this.$t("agentT"),
          key: "str3",
          width: 120,
        },
        {
          name: () => this.$t("clearagent"),
          key: "str4",
          width: 120,
        },
        {
          name: () => this.$t("air_agent"),
          key: "str5",
          width: 120,
        },
        {
          name: () => this.$t("distribution_agent"),
          key: "shipment.deliver",
          width: 120,
        },
        {
          name: () => this.$t("inboundTime"),
          key: "inbound_time",
          width: 120,
        },
        {
          name: () => this.$t("outbound_time"),
          key: "outbound_time",
          width: 120,
        },
        {
          name: () => this.$t("trajectory"),
          width: 95,
          key: "trace",
          children: [
            {
              name: () => this.$t("code"),
              key: "shipment.trace_code",
              width: 95,
            },
            {
              name: () => this.$t("deSc"),
              key: "shipment.trace_remarks",
              width: 110,
            },
            // {
            //   name: () => this.$t("tracker_description_cn"),
            //   key: "status_cn",
            //   minWidth: 100
            // },
            {
              name: () => this.$t("upTime"),
              key: "shipment.trace_time",
              width: 150,
            },
          ],
        },
        {
          name: () => this.$t(this.$t("clientName")),
          key: "clientInfo.account",
          width: 95,
        },
        {
          name: () => this.$t("order_number"),
          key: "airway_bill_number",
          minWidth: 130,
        },
        {
          name: () => this.$t("shipperRef"),
          key: "shipment.client_refer_code",
          width: 95,
        },
        {
          name: () => this.$t("transfer_num"),
          key: "shipment.agent_refer_code",
          width: 95,
        },

        {
          name: () => this.$t("salesman"),
          width: 95,
          key: "clientInfo.salesman.account",
        },

        {
          name: () => this.$t("channel_code"),
          key: "shipment.transport_mode",
          width: 95,
        },
        {
          name: () => this.$t("allow_depart"),
          key: "shipment.from_country",
          width: 95,
        },
        {
          name: () => this.$t("allow_arrive"),
          key: "shipment.to_country",
          width: 95,
        },
        {
          name: () => this.$t("city_name"),
          key: "shipment.city_name",
          width: 95,
        },
        {
          name: () => this.$t("remote_regions"),
          key: "shipment.remote_areas_txt",
          width: 110,
        },
        {
          name: () => this.$t("order_goods"),
          key: "goods_count",
          width: 100,
        },
        {
          name: () => this.$t("actual_weight"),
          key: "financeInfo.actual_weight",
          width: 95,
        },
        {
          name: () => this.$t("charge_volume"),
          key: "financeInfo.charge_volume",
          width: 95,
        },
        {
          name: () => this.$t("charge_params"),
          key: "financeInfo.charge_params",
          width: 95,
        },

        {
          name: () =>
            this.$t("charge_params") + "(" + this.$t("finances") + ")",
          key: "financeInfo.charge_weight_finance",
          width: 95,
        },
        {
          name: () => this.$t("charge_params") + this.$t("type"),
          key: "financeInfo.use_charge_type",
          width: 95,
        },

        {
          name: () => this.$t("actual_receipt") + this.$t("freight_fees"),
          width: 110,
          children: ["cny", "usd", "sar", "qar", "aed", "kwd"].map((t) => {
            let data = {
              name: t.toUpperCase(),
              key: "financeInfo.freight_fees_" + t,
              width: 95,
            };
            return data;
          }),
        },
        {
          name: () => this.$t("freight_fees") + this.$t("VATFee"),
          key: "financeInfo.freight_vat_fee",
          width: 95,
        },
        {
          name: () => this.$t("actual_receipt") + this.$t("freight_fees"),
          key: "financeInfo.total_freight",
          width: 95,
        },
        {
          name: () => this.$t("otherCost"),
          width: 110,
          key: "remote_fee",
          children: [
            {
              name: this.$t("remote_regions_fee"),
              key: "remote_fee_",
              child: ["cny", "usd"],
            },
            {
              name: this.$t("freight_append"),
              key: "other_fee_",
              child: ["cny", "usd", "sar", "qar", "aed", "kwd"],
              childBind: {
                noDeep: true,
                render: (h, { row, field }) => {
                  return h(
                    "Button",
                    {
                      attrs: {
                        size: "small",
                        type: "primary",
                      },
                      on: {
                        click: () => {
                          this.$refs["table"]
                            .getModal("feeModal")
                            .open({ row }, function () {
                              this.setTitle(
                                this.$t("freight_append") +
                                  "(" +
                                  row.airway_bill_number +
                                  ")"
                              );
                              this.list = row.financeInfo.otherFeeItem;
                            });
                        },
                      },
                    },
                    row.financeInfo["other_fee_" + field.data]
                  );
                },
              },
            },
            {
              name: this.$t("overweight_fee"),
              key: "ext_overweight_fee_",
              child: ["cny"],
            },
            {
              name: this.$t("overload_fee"),
              key: "ext_overload_fee_",
              child: ["cny"],
            },
            {
              name: this.$t("extra_charge"),
              key: "ext_op_fee_",
              child: ["cny"],
            },
            {
              name: this.$t("material_fee"),
              key: "ext_material_fee_",
              child: ["cny"],
            },
          ].map((t) => {
            let data = {
              name: t.name,
              key: t.key,
              width: 110,
              children: [],
            };
            data.children = t.child.map((c) => {
              return {
                name: c.toUpperCase(),
                key: "financeInfo." + t.key + c,
                width: 95,
                data: c,
                ...t.childBind,
              };
            });
            console.log(data.children, "t");
            return data;
          }),
        },
        {
          name: () => this.$t("taxFee") + " USD",
          width: 110,
          children: [
            {
              name: this.$t("total_tax"),
              key: "financeInfo.total_tax_usd",
              width: 95,
            },
            {
              name: this.$t("vat_fee") + " VAT",
              key: "financeInfo.vat_fee_usd",
              width: 95,
            },
            {
              name: this.$t("tax_fee") + " Duty",
              key: "financeInfo.tax_fee_usd",
              width: 95,
            },
            {
              name: this.$t("document_fee"),
              key: "financeInfo.document_fee_usd",
              width: 95,
            },
          ],
        },
        {
          name: () => this.$t("to") + this.$t("rate"),
          width: 110,
          children: [
            "freight_unit",
            "cny",
            "usd",
            "sar",
            "qar",
            "aed",
            "kwd",
          ].map((t) => {
            let data = {
              name:
                t === "freight_unit" ? this.$t("toCurrency") : t.toUpperCase(),
              key: "financeInfo." + (t === "freight_unit" ? t : t + "_to_rate"),
              width: 95,
            };
            return data;
          }),
        },
        {
          name: () => this.$t("receivable") + this.$t("total"),
          key: "financeInfo.total_amount",
          minWidth: 110,
        },
        {
          name: () => this.$t("COD"),
          width: 95,
          children: [
            {
              name: () => this.$t("currency_t"),
              key: "shipment.cod_currency",
              width: 95,
            },
            {
              name: () => this.$t("reChAmount"),
              key: "shipment.cod_amount",
              width: 95,
            },
          ],
        },
        {
          name: () => this.$t("bill_type"),
          key: "financeInfo.finance_status_txt",
          width: 80,
          methods: {
            render({ row }) {
              return row.financeInfo.finance_status_txt;
            },
          },
        },
        {
          name: () => this.$t("bill_number"),
          key: "financeInfo.bill_number",
          width: 110,
          noDeep: true,
          render: (h, { row }) => {
            if (row.financeInfo) {
              return h(
                "a",
                {
                  props: {
                    type: "warning",
                    size: "small",
                  },
                  on: {
                    click: () => {
                      this.$refs["table"].toPage(
                        "hw_bill_hq",
                        row.financeInfo.bill_number
                      );
                    },
                  },
                },
                row.financeInfo.bill_number
              );
            }
          },
        },
        {
          name: () => this.$t("bindFreight"),
          key: "financeInfo.quotation_name",
          align: "left",
          width: 95,
        },
        {
          name: () => this.$t("DeclaredValue"),
          key: "shipment.values",
          width: 95,
        },
        {
          name: () => this.$t("exlType"),
          key: "financeInfo.calculate_status_txt",
          type: "calculate_status",
          minWidth: 80,
          noDeep: true,
          bind: {
            style({ row }) {
              return {
                color:
                  row.financeInfo.calculate_status == 1 ? "#4caf50" : "#f44336",
              };
            },
          },
          methods: {
            render: ({ row }) => {
              return row.financeInfo.calculate_status == 1
                ? this.$t("billSuccess")
                : this.$t("billFailed");
            },
          },
        },
      ],
    };
  },
};
</script>
